import { select } from 'core/middlewares/utilities';

import type { RootState } from 'core/store';

/**
 * Get combo data
 *
 */
export function* getComboData() {
  const comboData: RootState['combo']['data'] = yield select(({ combo }: RootState) => combo.data);

  return comboData;
}

export type ComboData = RootState['combo']['data'];
